import React from "react";
import { Link } from "react-router-dom";

const DaySaleOne = () => {
  return (
    <section className="day-sale pt-80">
      <div className="container container-lg">
        <div className="daysale-banner-wrapper">
          <Link to="/container-locks-hinges" className="daysale-banner-link">
            <img
              src="assets/images/thumbs/containerlocks.png"
              alt="Container Locks and Hinges"
              className="daysale-banner-image"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DaySaleOne;
